"use client";

import dynamic from "next/dynamic";

const CreateSimulationForm = dynamic(
  () =>
    import("@/components/simulations/CreateSimulationForm").then(
      (mod) => mod.CreateSimulationForm,
    ),
  {
    ssr: false,
  },
);

interface SimulationPageContentProps {
  isDevMode: boolean;
}

export function SimulationPageContent({
  isDevMode,
}: SimulationPageContentProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
      <CreateSimulationForm
        creditBalance={0}
        isDevMode={isDevMode}
        showTitle={false}
      />
    </div>
  );
}
